import { ReactNode } from "react";
import { Box, SxProps, Theme } from "@mui/material";

interface ClipTextProps {
  children?: ReactNode;
  width?: number;
  sx?: SxProps<Theme>;
}

export function ClipText(props: ClipTextProps) {
  const { children, width, sx } = props;

  return (
    <Box
      sx={{
        width: (width ? width : 'none'),
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}